import { SimpleGrid, Group, Select, Button, TextInput } from "@mantine/core";
import { useForm, isEmail } from "@mantine/form";
import { DateInput } from "@mantine/dates";
import PlanFormPageShell from "../../../covers/components/PlanFormPageShell/PlanFormPageShell";
import classes from "./AddUser.module.css";

const AddUserForm = ({ onSubmit, groups, departments, title = "+ Add New Employee" }) => {
  const form = useForm({
    initialValues: {
      email: "",
      first_name: "",
      last_name: "",
      department_name: "",
      date_of_birth: "",
      gender: "",
      address: "",
      state: "",
      city: "",
      pin: "",
      country: "",
      tel_no: "",
      role: "",
    },
    validate: {
      email: isEmail("Invalid email"),
    },
  });

  return (
      <PlanFormPageShell title={title}>
      <form
        className={classes.loginForm}
        onSubmit={form.onSubmit(() => {
          onSubmit({
            ...form.values,
            date_of_birth: form.values.date_of_birth
              ? form.values.date_of_birth.toISOString().split("T")[0]
              : null,
          });
        })}
      >

        <SimpleGrid
          cols={{ base: 1, xs: 2, sm: 2, lg: 2 }}
          spacing={{ base: 10, xs: "xl", sm: "xl" }}
          className={classes.operatorProfileForm}
        >
          <TextInput
            placeholder="Enter user first name"
            label="First name"
            type="text"
            size="sm"
            {...form.getInputProps("first_name")}
          />
          <TextInput
            placeholder="Enter user last name"
            label="Last name"
            type="text"
            size="sm"
            {...form.getInputProps("last_name")}
          />
          <TextInput
            placeholder="Enter user email"
            label="Email"
            type="text"
            size="sm"
            {...form.getInputProps("email")}
          />
          {/* <DateInput
            placeholder="Enter user date of birth"
            label="Date of Birth"
            size="sm"
            {...form.getInputProps("date_of_birth")}
          /> */}
          <DateInput
            placeholder="Enter user date of birth"
            label="Date of Birth"
            size="sm"
            valueFormat="YYYY-MM-DD"
            {...form.getInputProps("date_of_birth")}
          />
          <Select
            label="Gender"
            data={["Male", "Female", "Other"]}
            placeholder="Select gender"
            value={form.values.gender}
            onChange={(value) => form.setFieldValue("gender", value)}
          />
          <TextInput
            placeholder="Enter user phone number"
            label="Phone No"
            type="text"
            size="sm"
            {...form.getInputProps("tel_no")}
          />
          <TextInput
            placeholder="Enter user address"
            label="Address"
            type="text"
            size="sm"
            {...form.getInputProps("address")}
          />
          <TextInput
            placeholder="Enter user pin"
            label="Pin"
            type="text"
            size="sm"
            {...form.getInputProps("pin")}
          />
          <TextInput
            placeholder="Enter user city"
            label="City"
            type="text"
            size="sm"
            {...form.getInputProps("city")}
          />
          <TextInput
            placeholder="Enter user state"
            label="State"
            type="text"
            size="sm"
            {...form.getInputProps("state")}
          />
          <TextInput
            placeholder="Enter user country"
            label="Country"
            type="text"
            size="sm"
            {...form.getInputProps("country")}
          />
          <Select
            label="Department"
            placeholder="Select department"
            data={departments}
            value={form.values.department_name}
            onChange={(value) => form.setFieldValue("department_name", value)}
          />
          <Select
            label="Roles"
            placeholder="Select user roles"
            data={groups}
            value={form.values.role}
            onChange={(value) => form.setFieldValue("role", value)}
          />
        </SimpleGrid>

        <Group justify="center" className={classes.buttonWraper}>
          <Button variant="gradient" type="submit" size="md">
            Submit
          </Button>
        </Group>
      </form>
    </PlanFormPageShell> 
  );
};

export default AddUserForm;